import { render, staticRenderFns } from "./ApplicationFormFooter.vue?vue&type=template&id=3667659d"
import script from "./ApplicationFormFooter.vue?vue&type=script&lang=js"
export * from "./ApplicationFormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports